import { useTranslation } from 'next-i18next'
import clsx from 'clsx'
import { ErrorMessage, Field } from 'formik'

import { getZodMessage } from 'utils/validation.util'

import styles from 'styles/Switch.module.scss'

import { InputStyle } from './Input'
import { IFieldProps } from './types'

const FieldSwitch = ({
  name,
  label,
  onClick,
  isVertical,
  helperText,
  disableErrorMessage,
  className,
  switchClassName,
  switchSliderClassName
}: IFieldProps) => {
  const { t } = useTranslation('zod')
  if (isVertical) {
    return (
      <div className="relative mt-4 flex w-full cursor-pointer flex-col items-start">
        <span
          className={clsx(
            // styles.switch__label,
            'ml-0 mb-4',
            'text-lg font-semibold leading-tight text-slate-900',
            className
          )}
        >
          {label}
        </span>
        <label className={clsx(styles.switch, switchSliderClassName)}>
          <Field
            type="checkbox"
            name={name}
            className={styles.switch__input}
            onClick={onClick}
          />
          <span
            className={clsx(
              styles.switch__slider,
              'border border-black/10',
              switchSliderClassName
            )}
          ></span>
          <span
            className={clsx(
              styles.switch__label,
              'text-lg leading-tight text-slate-400'
            )}
          >
            {helperText}
          </span>
        </label>
        <div className={InputStyle.info}>
          <ErrorMessage
            name={name}
            render={(msg) =>
              typeof msg === 'string' ? (
                <div className="fade-in text-medium text-error-400">
                  {getZodMessage(msg, t(msg, { ns: 'zod' }))}
                </div>
              ) : null
            }
          />
        </div>
      </div>
    )
  }
  return (
    <div className="my-4 ml-2 flex w-full cursor-pointer items-center">
      <div className="flex flex-col gap-3">
        <label className={clsx(styles.switch, switchClassName)}>
          <Field
            type="checkbox"
            name={name}
            className={styles.switch__input}
            onClick={onClick}
          />
          <span
            className={clsx(styles.switch__slider, switchSliderClassName)}
          ></span>
          <span
            className={clsx(
              styles.switch__label,
              'text-lg font-semibold leading-tight text-slate-900',
              className
            )}
          >
            {label}
          </span>
        </label>
        <span
          className={clsx(
            styles.switch__label,
            '!ml-0 mt-10 text-lg leading-tight text-slate-400 sm:mt-6 md:mt-4 lg:mt-0'
          )}
        >
          {helperText}
        </span>
      </div>
      {!disableErrorMessage && (
        <div className={clsx(InputStyle.info, '-mt-5')}>
          <ErrorMessage
            name={name}
            render={(msg) =>
              typeof msg === 'string' ? (
                <div className="fade-in text-medium text-error-400">
                  {getZodMessage(msg, t(msg, { ns: 'zod' }))}
                </div>
              ) : null
            }
          />
        </div>
      )}
    </div>
  )
}

export default FieldSwitch
